type DeviceFeatureTeam = {
  device_enabled?: boolean | null
}

const teamHasDevices = (team?: DeviceFeatureTeam | null): boolean => {
  if (!team) return false

  return team.device_enabled !== false
}

export default teamHasDevices
